import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import companyLogo from '../assets/company-logo.svg';
import { loginUser } from '../api/authService';

const API_URL = process.env.REACT_APP_API_URL || "";

function Login({ onLogin }) {
  const [form, setForm] = useState({ email: '', password: '', rememberMe: false });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [serverError, setServerError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  
  const redirectTo = location.state?.from || '/';

  const validateForm = () => {
    const newErrors = {};
    
    if (!form.email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(form.email)) {
      newErrors.email = 'Email is invalid';
    }
    
    if (!form.password) {
      newErrors.password = 'Password is required';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ 
      ...form, 
      [name]: type === 'checkbox' ? checked : value 
    });
    
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ''
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setServerError('');
    
    if (!validateForm()) return;
    
    setIsSubmitting(true);
    
    try {
      const data = await loginUser({
        email: form.email,
        password: form.password,
        rememberMe: form.rememberMe
      });
      
      onLogin(data.user);
      navigate(redirectTo);
    } catch (err) {
      if (err.statusCode === 401) {
        setServerError('Invalid email or password');
      } else if (err.statusCode === 403) {
        setServerError('Please verify your email before logging in');
      } else if (err.message) {
        setServerError(err.message);
      } else {
        setServerError('An error occurred during login. Please try again.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="container-auth">
      <div className="box-auth">
        <div className="logo-wrapper">
          <img src={companyLogo} alt="Redwood Midcap" className="logo" />
        </div>
        
        <div className="auth-error-container">
        {serverError && (
          <div className="auth-error-message">{serverError}</div>
        )}
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="form-header-auth">
            <h2>Login</h2>
            <p>Enter your email below to login to your account</p>
          </div>
          
          <div className={`form-group-auth ${errors.email ? 'error' : ''}`}>
            <label className="label-auth" for="email">Email</label>
            <input 
              className="input-field-auth" 
              type="email" 
              id="email" 
              name="email" 
              placeholder="test@example.com" 
              value={form.email}
              onChange={handleChange}
              disabled={isSubmitting}
              autoComplete="email"
            />
          </div>

          <div class="forgot-password">
            <label className="label-auth" for="password">Password</label>
            <Link to="/forgot-password">Forgot your password?</Link>
          </div>

          <div className={`form-group-auth ${errors.password ? 'error' : ''}`}>
            <input 
  	          className="input-field-auth"
              type="password"
              id="password"
              name="password"
              placeholder="Password"
              value={form.password}
              onChange={handleChange}
              disabled={isSubmitting}
              autoComplete="current-password"
            />
          </div>
          
          <div className="remember-me">
            <input
              id="rememberMe"
              type="checkbox"
              name="rememberMe"
              checked={form.rememberMe}
              onChange={handleChange}
              disabled={isSubmitting}
            />
            <label className="label-auth" htmlFor="rememberMe">Remember me</label>
          </div>
          
          <button 
            className="button-auth"
            type="submit" 
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                Logging in<span className="dots" />
              </>
            ) : (
              'Login'
            )}
          </button>
        </form>
        
        <p className="signup-text">
          Don't have an account? <Link to="/register">Create Account</Link>
        </p>
      </div>
    </div>
  );
}

export default Login;